import { lens } from '@core/zustand/lens'

import { createPlayerState } from './state'
import type { PlayerGlobalState } from './types'

export const PLAYER_SLICE_KEY = 'player'

export interface IPlayerGlobalStateSlice {
  [PLAYER_SLICE_KEY]: PlayerGlobalState
}

/**
 * Creates a slice of the global state for the player.
 */
export function createPlayerSlice(): IPlayerGlobalStateSlice {
  return {
    [PLAYER_SLICE_KEY]: lens((set) => createPlayerState(set)),
  }
}
